<template>
<div class="page-points-mall container">
  <div class="points-mall-header">
    <div class="points-mall-header-flex">
      <div class="header-name">我的积分</div>
      <div class="header-value">{{pointsData.points}}</div>
      <div class="header-tips" v-if="pointsData.userPointAlarmDays">积分还有{{pointsData.userPointAlarmDays}}天就过期了，请尽快使用哦</div>
    </div>
  </div>
  <van-list class="container-flex bg" v-model="loading"
                :finished="isAll"
                finished-text="没有更多了"
                @load="scrollToLower">
  <!-- <van-list  scroll-y="true"  bindscrolltolower="scrollToLower"> -->
    <div class="goods-list">
      <div class="goods-item" v-for="(item,index) in goodsList" :key="index" @click="exchange(item)">
        <div class="goods-img-box">
          <img class="goods-img" :src="$config.fileUrl + item.pictureUrl" />
        </div>
        <div class="goods-info">
          <div class="goods-name text-hide">
            <img src="../../assets/image/mall-discount.png" v-if="item.discountRatio != 100" class="discount-icon" />
            {{item.productName}}
          </div>
          <div class="goods-pay-box">
            <div class="money">{{item.discountRatio != 100 ? item.discountPrice : item.price}}积分</div>
            <div class="">
              <div class="money-btn record-btn" >立即兑换</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="no-list-data" v-if="!isAll && goodsList.length > 0">暂无更多数据</div>
    <div class="no-list-data" v-if="isAll && goodsList.length > 0">上拉加载更多</div> -->
  </van-list>
</div>  
</template>

<script>
import { getUserPoints, getMallProductPage } from "../../common/api/index";
import { List } from "vant";
export default {
  name: "points-mall",
  components: {
    [List.name]: List,
  },
  data() {
    return {
      pointsData: {},
      isAll: false,
      globalPageIndex: 1,
      goodsList: [],
      loading: false
    };
  },
  methods: {
    exchange(item) {
      this.$common.save("pointsGoodsDetails", item);
      this.$router.push("/points-goods-details");
    },
    scrollToLower() {
      // if (!this.isAll && !this.loading) {
        this.globalPageIndex = this.globalPageIndex + 1;
        this.getTableList();
      // }
    },
    async getUserPoints() {
      let ret = await getUserPoints({});
      if (ret.status === 0) {
        let data = ret.data[0];
        this.pointsData = data;
      }
    },
    async getTableList() {
      this.loading = true;
      const ret = await getMallProductPage({
        globalPageIndex: this.globalPageIndex,
        globalPageSize: 10,
        productStatus: "0",
      });
      if (ret.status === 0) {
        let data = ret.data || [];
        this.goodsList.push(...data);
        if (this.goodsList.length >= ret.total) {
          this.isAll = true;
        }
      }
      this.loading = false;
    },
  },
  mounted() {
    this.getUserPoints();
    this.getTableList();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";
.page-points-mall {
  .points-mall-header {
    padding: 0.3rem 0.4rem;
    background-color: #14cc80;
    color: #fff;
    display: flex;
  }
  .points-mall-header-flex {
    flex: 1;
  }
  .header-name {
    font-size: 0.26rem;
    line-height: 0.37rem;
  }
  .header-value {
    font-size: 0.48rem;
    line-height: 0.67rem;
  }
  .header-tips {
    font-size: 0.18rem;
    line-height: 0.25rem;
  }
  .header-right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .record-btn {
    height: 0.38rem;
    border-radius: 0.28rem;
    border: 1px solid #ffffff;
    font-size: 0.24rem;
    line-height: 0.33rem;
    display: inline-block;
    padding: 0.03rem 0.17rem;
  }
  /* .container-flex{
    background-color:#F5F4F9
  } */
  .goods-list {
    display: flex;
    flex-wrap: wrap;
  }
  .goods-item {
    width: 3.45rem;
    background-color: #fff;
    margin-left: 0.2rem;
    margin-top: 0.2rem;
    border-radius: 0.12rem;
  }
  .goods-img-box {
    height: 3rem;
    margin: 0.05rem;
  }
  .goods-img {
    width: 100%;
    height: 100%;
  }
  .goods-info {
    padding: 0.1rem 0.2rem 0.2rem 0.2rem;
  }
  .goods-name {
    color: #666;
    font-size: 0.24rem;
    line-height: 0.33rem;
  }
  .discount-icon {
    width: 0.4rem;
    height: 0.22rem;
    vertical-align: text-bottom;
  }
  .goods-pay-box {
    display: flex;
    margin-top: 0.1rem;
  }
  .goods-pay-box .money {
    font-size: 0.38rem;
    line-height: 0.53rem;
    color: #333;
    flex: 1;
  }
  .goods-pay-box .money-btn {
    border-color: #14cc80;
    color: #14cc80;
    margin-top: 0.12rem;
  }
}
</style>
